import { useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '~/utils/trpc'

export const useInvalidateMeterPhotos = () => {
  const trpc = useTRPC()
  const queryClient = useQueryClient()

  // A meter photo can change its installation's image and compatibility, so its detail refetches too.
  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: trpc.ops.compatibilityReview.pathKey() }),
      queryClient.invalidateQueries({ queryKey: trpc.ops.stationInstallations.get.pathKey() })
    ])
}
